var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3 40.1C76.3 20.2 60.2 4.09998 40.3 4.09998C20.4 4.09998 4.29999 20.2 4.29999 40.1C4.29999 60 20.4 76.1 40.3 76.1C60.2 76.1 76.3 60 76.3 40.1ZM7.59999 40.1C7.59999 22 22.3 7.39998 40.3 7.39998C58.3 7.39998 73 22.1 73 40.1C73 58.1 58.4 72.8 40.3 72.8C22.2 72.8 7.59999 58.2 7.59999 40.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 60.9V40.1H48.6L49.7 33.2H41.8V29.7C41.8 27.9 42.4 26.2 45 26.2H50.2V19.3H42.9C36.7 19.3 35.1 23.4 35.1 29V33.2H30.9V40.1H35.1V60.9H41.7V60.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footer-facebook.e21ab7f8.svg";
export { ForwardRef as ReactComponent };